const products_on_page = $(".products-on-page")
var next_url = products_on_page.data("next-url")
var last_element = document.querySelector(".load-more");
var load_more_spinner = document.querySelector(".load-more__spinner");
var ready = true; //Assign the flag here

addEventListener("scroll", (event) => {
    var elementRect = last_element.getBoundingClientRect();

    // Check if the element is fully or partially visible on the screen
    if (ready && (elementRect.top < window.innerHeight && elementRect.bottom >= 0)) {
        ready = false;
        // run your function
        load_more_products();
    }
});

const load_more_products = () => {
    load_more_spinner.style.display="block";
    if (next_url) {
      fetch(next_url, {
        method: "GET",
        headers: {
          "Content-Type": "text/html"
        }
      })
      .then(response => response.text())
      .then(next_page => {
        // do something with the HTML
          let new_products = $(next_page).find(".products-on-page")
          products_on_page.append(new_products.html())
          let new_url = new_products.data("next-url")

          if(new_url){
            ready = true;
          }
        //   if no more products new_url = ''
          if (new_url === "") {
            last_element.innerHTML = '- NO MORE PRODUCT -';
            load_more_spinner.style.display="none";
          }
          next_url = new_url
      })
      .catch(error => {
        console.error(error);
      });
    } else {
      last_element.innerHTML = '- NO MORE PRODUCT -';
      load_more_spinner.style.display="none";
    }
}

